var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    [
      _c("b-card", { staticClass: "multi-card" }, [
        _c(
          "div",
          { attrs: { slot: "header" }, slot: "header" },
          [
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { md: "8" } }, [
                  _c("h5", [_vm._v(_vm._s(_vm.$t("CONFIGURED.FORM_ORDER")))])
                ]),
                _vm._v(" "),
                _c("b-col", { attrs: { md: "4" } }, [
                  _c(
                    "div",
                    { staticClass: "float-right add-field-btn" },
                    [
                      _c(
                        "i",
                        {
                          staticClass: "fa fa-lg mr-1 fa-info-circle",
                          attrs: { id: "popover-target" }
                        },
                        [
                          _c(
                            "b-popover",
                            {
                              attrs: {
                                target: "popover-target",
                                triggers: "hover",
                                placement: "top"
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("COMMON.PROCESS_ORDER_INFO")) +
                                  "\n              "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "mt-0",
                          attrs: {
                            type: "submit",
                            size: "sm",
                            variant: "secondary"
                          },
                          on: { click: _vm.updateOrder }
                        },
                        [
                          _c("i", { staticClass: "fa fa-save" }),
                          _vm._v(" " + _vm._s(_vm.$t("COMMON.SAVE")))
                        ]
                      )
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "timeline-div" }, [
          _c(
            "ul",
            { staticClass: "timeline timeline-horizontal" },
            [
              _c(
                "draggable",
                {
                  staticClass: "flex-container",
                  attrs: { options: { group: "processing" } },
                  model: {
                    value: _vm.processingOrders,
                    callback: function($$v) {
                      _vm.processingOrders = $$v
                    },
                    expression: "processingOrders"
                  }
                },
                _vm._l(_vm.processingOrders, function(processingOrder, index) {
                  return _c(
                    "li",
                    { key: processingOrder.name, staticClass: "timeline-item" },
                    [
                      _c("div", { staticClass: "timeline-badge bg-primary" }, [
                        _c("strong", [_vm._v(_vm._s(index + 1))])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "timeline-panel" }, [
                        _c("p", [
                          _vm._v(_vm._s(_vm.getName(processingOrder.name)))
                        ])
                      ])
                    ]
                  )
                })
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("em", { staticClass: "italic" }, [
          _vm._v(_vm._s(_vm.$t("CONFIGURED.NOTE")))
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56762b2b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56762b2b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/processOrder.vue
// module id = 1331
// module chunks = 2